export default __webpack_public_path__ + "static/media/targa_europe_2019.44190509.webp";